import { render, staticRenderFns } from "./SeminarMembers.vue?vue&type=template&id=3ddcfc20&scoped=true&"
import script from "./SeminarMembers.vue?vue&type=script&lang=js&"
export * from "./SeminarMembers.vue?vue&type=script&lang=js&"
import style0 from "./SeminarMembers.vue?vue&type=style&index=0&id=3ddcfc20&lang=scss&scoped=true&"
import style1 from "./SeminarMembers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddcfc20",
  null
  
)

export default component.exports